<template>
  <div class="backpackList">
    <!--操作栏-->

    <div class="action-bar">
      <el-input
        v-model.number="params.uid"
        placeholder="请输入用户ID"
        size="small"
        clearable
        class="param-input"
      ></el-input>
      <el-select
        v-model="params.status"
        size="small"
        clearable
        placeholder="请选择使用状态"
        @change="getList('status')"
      >
        <el-option
          v-for="item in statusList"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="params.goodType"
        size="small"
        clearable
        placeholder="请选择物品类型"
        @change="getList('status')"
      >
        <el-option
          v-for="item in goodTypes"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="search('status')"
        >搜索</el-button
      >
    </div>

    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
    >
      <el-table-column prop="uid" label="用户ID" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="goodsName" label="物品名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.goodsName || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="goodsOrigin" label="获取方式" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.goodsOrigin || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="使用状态" align="center">
        <template slot-scope="scope">
          <span>{{ handleStatus(scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="goodsType" label="物品类型" align="center">
        <template slot-scope="scope">
          <span>{{ handleType(scope.row.goodsType) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTimt" label="创建时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createTimt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="useTime" label="使用时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.useTime | changeDate }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>
<script>
import { paramsFilter } from "@/utils/global";
import API from "@/api";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: "",
      total: 0,
      // 物品类型
      goodTypes: [
        {
          label: "会员折扣券",
          value: 2,
        },
        {
          label: "ai换脸折扣券",
          value: 4,
        },
      ],
      statusList: [
        {
          label: "已使用",
          value: 1,
        },
        {
          label: "未使用",
          value: 2,
        },
        {
          label: "过期",
          value: 3,
        },
      ],
      // 用户管理列表请求参数
      params: {
        uid: undefined,
        status: undefined,
        goodType: undefined,
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 请求黑名单列表
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      let params = paramsFilter(this.params);
      API.getBackpackList(params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleStatus(sta) {
      let str = "-";
      switch (sta) {
        case 1:
          str = "已使用";
          break;
        case 2:
          str = "未使用";
          break;
        case 3:
          str = "过期";
          break;
        default:
          str = "--";
          break;
      }
      return str;
    },
    handleType(type) {
      let str = "-";
      switch (type) {
        case 2:
          str = "会员折扣券";
          break;
        case 4:
          str = "ai换脸折扣券";
          break;
        default:
          str = "--";
          break;
      }
      return str;
    },

    // 搜索对应列表
    search(type) {
      this.params.pageNumber = 1;
      this.getList(type);
    },
    // 监听新增成功回掉
    getAddblack() {
      this.getList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
  },
};
</script>
<style lang="scss"></style>
